// removed by extract-text-webpack-plugin
module.exports = {"MainPage":"MainPage__MainPage--kAFQT","titleP":"MainPage__titleP--1-MkU","mainNav":"MainPage__mainNav--8Hum7","mainImg":"MainPage__mainImg--3P79C","articalImg":"MainPage__articalImg--2FKJU","shortArticle":"MainPage__shortArticle--sQTic","heading":"MainPage__heading--3Nw-0","redP":"MainPage__redP--3xJve","navContainer":"MainPage__navContainer--2hX2F","mainContent":"MainPage__mainContent--165pe","col-5":"MainPage__col-5--YbtsB"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/MainPage/MainPage.css
// module id = 75
// module chunks = 0